export const UNIT_CREATION_MODES = {
	CREATE_NEW: 'CREATE_NEW',
	COPY_EXISTING: 'COPY_EXISTING'
};
